export enum CasinoConfigVersion {
  JSON = 'json',
  JSP = 'jsp',
}

export interface CasinoConfigType {
  bonusBalance?: boolean;
  cashierIframeEvent?: boolean;
  cashierPopupEnabled?: boolean;
  cashierUrl?: string;
  cashierUrlFirst?: string;
  cashierUrlMobile?: string;
  casinoId: string;
  casinoName: string;
  casinoRegion?: string;
  chatDisabled?: boolean;
  exitUrl?: string;
  forceAutoplayShow?: boolean;
  forceHideNetPosition?: boolean;
  heroBanners?: string[];
  hideAutoplay?: boolean;
  hideBonusBalance?: boolean;
  hideCurrency?: boolean;
  hideFullScreenBtn?: boolean;
  hideLobbyButtons?: boolean;
  homeUrl?: string;
  integrationApi?: string[];
  isManualPayout?: boolean;
  isMicroGamingEnabled?: boolean;
  isSessionBalanceEnabled?: boolean;
  lobbyVersion?: string;
  languages: string[];
  notifyCloseContainer?: boolean;
  returnMainPage?: boolean;
  showAlderneyMsg?: boolean;
  showBonusBalance?: boolean;
  showNicknameDisclaimer?: boolean;
  slotsLobbyEnabled: boolean;
  tables: Record<string, string[]>;
  tabs: string[];
  voiceOverTables: string[];
}

export interface ICasinoConfigJson {
  casinoId: string;
  casinoName: string;
  casinoRegion: string;
  params: {
    apply_dga_optimisation: string;
    bonus_balance: string;
    cashier_iframe_event?: string;
    cashier_mobile?: string;
    cashier_popup_enabled?: string;
    cashier_url?: string;
    cashier_url_first?: string;
    chat_disabled?: string;
    chat_logo_bg: string;
    clr_desktop: string;
    clr_mobile: string;
    displaynicknamedisclaimer: string;
    enable_delta_messages: string;
    enable_multibaccarat: string;
    error_return_page: string;
    estimated_micro_game_session_time: string;
    exit_url?: string;
    flags_lobby_tiles: string;
    game_round_event: string;
    gamecare_choice: string;
    gmt_eight: string;
    hero_banners?: string;
    hide_bonus?: string;
    hide_currency: string;
    hide_inner_wheel: string;
    hide_lobby_buttons: string;
    hidefullscreenbtn?: string;
    home_url?: string;
    integration_api?: string;
    ismanualpayout?: string;
    italianlobbyenabled?: string;
    languages: string;
    leaderboards: string;
    lobby_bg: string;
    lobby_logo: string;
    lobby_version?: string;
    micro_gaming: string;
    mobile_site: string;
    multi_table_shortcuts: string;
    net_position: string;
    notify_close_container?: string;
    ping_language_timer: string;
    powerup_consolation_bonus: string;
    public_chat_filtration: string;
    rank_enabled: string;
    ranking_image: string;
    remove_autoplay_uk?: string;
    return_main_page?: string;
    roulette_desktop_bg: string;
    sendpositiveadjonly: string;
    show_alderney_msg?: string;
    show_nickname_disclaimer: string;
    show_session_timer: string;
    slotslobbyenabled: string;
    subscriptiontoautoadjustmentapi: string;
    syschat_enabled: string;
    tables_order: string;
    tabs_order: string;
    tipping_enabled: string;
    voice_over_tables: string;
  };
}
